<h2 style="margin-bottom: 16px;">AI Feedback</h2>
<p style="margin-bottom: 8px; font-weight: 500;">
  Total: {{ filtered.length }}
</p>
<input
  nz-input
  placeholder="Search by question"
  [(ngModel)]="searchText"
  (ngModelChange)="applySearch()"
  style="width: 240px; margin-bottom: 16px;"
/>

<nz-table
  #table
  [nzData]="filtered"
  [nzBordered]="true"
  [nzLoading]="loading"
  [nzSize]="'middle'"
  [nzScroll]="{ x: '1000px' }"
  [nzShowSizeChanger]="true"
  [nzShowQuickJumper]="true"
>
  <thead>
  <tr>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['question']"
      (nzSortOrderChange)="changeSort('question', $event)"
    >
      Question
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['answer']"
      (nzSortOrderChange)="changeSort('answer', $event)"
    >
      Answer
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['feedback']"
      (nzSortOrderChange)="changeSort('feedback', $event)"
    >
      Feedback
    </th>
    <th
      nzShowSort
      [nzSortFn]="true"
      [nzSortOrder]="sortMap['createdAt']"
      (nzSortOrderChange)="changeSort('createdAt', $event)"
    >
      Submitted
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let f of table.data">
    <td>{{ f.question }}</td>
    <td>{{ f.answer }}</td>
    <td>{{ f.feedback }}</td>
    <td>{{ f.createdAt | date: 'short' }}</td>
  </tr>
  </tbody>
</nz-table>
